/**
 * The window policy of the tenant-cluster status-history read — how far back one
 * call reaches by default and at most. Shared by the admin contract that
 * validates a request and the backend that resolves one, so the two cannot
 * disagree about what a valid window is.
 */

/** The default window when the caller names no `from`. */
export const VIBE_STATUS_HISTORY_DEFAULT_WINDOW_DAYS = 14;

/** The widest window one call may ask for. */
export const VIBE_STATUS_HISTORY_MAX_WINDOW_DAYS = 90;
